import {
  animalBirthUpdateConverter,
  animalBreedUpdateConverter,
  animalConvertor,
  animalDetailsConverter,
  animalGenderUpdateConverter,
  animalHouseTrainedUpdateConverter,
  animalNameUpdateConverter,
  animalProfilePictureUpdateConverter,
  animalReproductiveUpdateConverter,
  animalSpeciesUpdateConverter,
  animalWeightUpdateConverter,
  createAnimalConvertor,
  animalTypeChangeResultConvertor,
  getAnimalInfoListConvertor,
  deleteVetRecordConvertor,
  applicationAnimalConvertor,
  confirmPaymentConvertor,
  completeAnimalConvertor,
  animalDetailsByIdConverter,
  animalVetRecordConvertor,
  animalMoveOutConvertor,
  unAuthorizedResidencyConverter,
  convertAnimalToPetConverter,
  animalMetadataConverter,
  convertAnimalToESAConverter,
  // updateAnimalConversionHPDocsConverter,
  convertAnimalToSAConverter,
  incompleteAnimalsData,
  updateVaccinationRecordsConverter,
  animalAggressionUpdateConverter,
  animalConvertedAcknowledgmentConverter,
  animalTrainedForUpdateConverter,
  animalMicrochipUpdateConverter,
  updateAnimalColorsConvertor,
} from 'data/convertors/animal.convertors';
import { pageableDataConverter } from 'data/convertors/pageableData.converters';
import {
  TAnimalBirthDateUi,
  TAnimalBreedUpdateUi,
  TAnimalDetails,
  TAnimalDetailsUi,
  TAnimalFormDataUI,
  TAnimalGenderUpdateUi,
  TAnimalGet,
  TAnimalHouseTrainedUpdateUi,
  TAnimalNameUpdateUi,
  TAnimalPostUI,
  TAnimalProfileUpdateUi,
  TAnimalReproductiveUpdateUi,
  TAnimalSpeciesUpdateUi,
  TAnimalVetRecordCreateUi,
  TAnimalVetRecordsList,
  TAnimalVetRecordsListUi,
  TAnimalWeightUpdateUi,
  TVetRecordDocumentsUI,
  TVetRecordUI,
  TApplicationAnimal,
  TApplicationAnimalUI,
  TConfirmPaymentUi,
  TCompleteAnimalFormDataUI,
  TAnimalDetailsByIdUi,
  TAnimalDetailsById,
  TMoveOutFormUI,
  TUnAuthorizedResidencyUI,
  TUnAuthorizedResidencyDB,
  TConvertAnimalToPetUI,
  TAnimalMetadata,
  TAnimalMetadataUi,
  TConvertAnimalToEsaUI,
  // TUpdateAnimalConvHPDocsUI,
  TConvertAnimalToSaUI,
  TCreateAnimalIncompleteUI,
  TIncompleteAnimalsDataDB,
  TIncompleteAnimalsDataUI,
  TAnimalDuplicationDB,
  TAnimalDuplicationUI,
  TAnimalAggressionUpdateUI,
  TConfirmAnimalTypeUI,
  TConvertedToPetAcknowledgmentDB,
  TConvertedToPetAcknowledgmentUI,
  TConvertedToPetResolveUI,
  TAnimalMicrochipUI,
  TAnimalCreateReturnedDataDB,
  TAnimalCreateReturnedDataUI,
  TAnimalCompleteResultDB,
  TAnimalCompleteResultUI,
  TAnimalTypeChangeResultDB,
  TAnimalTypeChangeResultUI,
  TAnimalTrainedForUpdateUi,
  TUpdateAnimalColorsUI,
} from 'data/types/animal.types';
import { TOptionType, TOptionTypeUi } from 'data/types/generalTypes';
import {
  TPageableDataWithContentUi,
  TPageableParamUI,
} from 'data/types/pagableData.type';
import { EAnimalUrls } from 'data/urls/animal.url';
import { EApplicationUrls } from 'data/urls/application.url';
import { authSplitApi } from '../helpers/slice.helpers';
import {
  incompleteAnimalConverter,
  incompleteAnimalsConverte,
} from '../../data/convertors/application.converters';

export const animalApi = authSplitApi('animal', [
  'animal',
  'animalMetadata',
  'species',
  'breeds',
  'colors',
  'animals',
  'animalById',
  'vetRecords',
  'applicationAnimal',
  'moveOutPreview',
  'incompleteAnimals',
  'convertedToPet',
]).injectEndpoints({
  endpoints: build => ({
    createAnimal: build.mutation<
      TAnimalCreateReturnedDataUI,
      TAnimalFormDataUI
    >({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}`,
          method: 'POST',
          body: createAnimalConvertor.toDb(body),
        };
      },
      transformResponse: (data: TAnimalCreateReturnedDataDB) =>
        createAnimalConvertor.fromDb(data),
      // PP-10057: creating can also self-convert to Pet and be auto-retracted, which changes what
      // is left to complete — the home-page banner reads that list.
      invalidatesTags: ['animals', 'incompleteAnimals'],
    }),
    createIncompleteAnimal: build.mutation<
      // transformResponse already produces the UI shape; the result was declared as the DB type.
      TAnimalDuplicationUI,
      TCreateAnimalIncompleteUI
    >({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.INCOMPLETE}`,
          method: 'POST',
          body: incompleteAnimalConverter.toDb(body),
        };
      },
      transformResponse: (data: TAnimalDuplicationDB) =>
        incompleteAnimalsConverte.fromDb(data),
      invalidatesTags: ['animals', 'incompleteAnimals'],
    }),

    completeAnimal: build.mutation<
      TAnimalCompleteResultUI,
      TCompleteAnimalFormDataUI
    >({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.COMPLETE}`,
          method: 'PUT',
          body: completeAnimalConvertor.toDb(body),
        };
      },
      // The endpoint has always answered with an object, not a bare boolean, so the old
      // pass-through made isConvertedToPet permanently truthy.
      transformResponse: (data: TAnimalCompleteResultDB) =>
        completeAnimalConvertor.fromDb(data),
      invalidatesTags: ['animals', 'incompleteAnimals'],
    }),
    createVetRecord: build.mutation<void, TAnimalVetRecordCreateUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.ATTACH_VET_RECORD}`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['vetRecords', 'animal', 'applicationAnimal'],
    }),
    confirmPayment: build.mutation<void, TConfirmPaymentUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.PAY}`,
          method: 'POST',
          body: confirmPaymentConvertor.toDb(body),
        };
      },
      invalidatesTags: ['vetRecords', 'animal', 'applicationAnimal'],
    }),
    getAnimals: build.query<
      TPageableDataWithContentUi<TAnimalPostUI[]>,
      TPageableParamUI
    >({
      query(params) {
        return {
          url: `${EAnimalUrls.ANIMALS}`,
          method: 'GET',
          params: { ...params },
        };
      },
      providesTags: ['animals'],
      transformResponse: (data: TPageableDataWithContentUi<TAnimalGet[]>) => {
        return {
          ...pageableDataConverter.fromDb(data),
          content: data?.content?.length
            ? data.content.map(animal => animalConvertor.fromDb(animal))
            : [],
        };
      },
    }),
    convertAnimalToPet: build.mutation<
      TAnimalTypeChangeResultUI,
      TConvertAnimalToPetUI
    >({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.TYPE}/${EAnimalUrls.TO_PET}`,
          method: 'PATCH',
          body: convertAnimalToPetConverter.toDb(body),
        };
      },
      // PP-10057: the conversion can leave applications retracted at properties that do not manage
      // the new type; the caller shows the tenant which residency was affected.
      transformResponse: (data: TAnimalTypeChangeResultDB) =>
        animalTypeChangeResultConvertor.fromDb(data),
      invalidatesTags: [
        'animal',
        'animals',
        'convertedToPet',
        'incompleteAnimals',
      ],
    }),
    convertAnimalToESA: build.mutation<
      TAnimalTypeChangeResultUI,
      TConvertAnimalToEsaUI
    >({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.TYPE}/${EAnimalUrls.TO_ESA}`,
          method: 'PATCH',
          body: convertAnimalToESAConverter.toDb(body),
        };
      },
      // PP-10057: the conversion can leave applications retracted at properties that do not manage
      // the new type; the caller shows the tenant which residency was affected.
      transformResponse: (data: TAnimalTypeChangeResultDB) =>
        animalTypeChangeResultConvertor.fromDb(data),
      invalidatesTags: ['animal', 'animals', 'incompleteAnimals'],
    }),
    updateAnimalToESAConversion: build.mutation<void, TConvertAnimalToEsaUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.TYPE}/${EAnimalUrls.TO_ESA}`,
          method: 'PUT',
          body: convertAnimalToESAConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'incompleteAnimals'],
    }),
    convertAnimalToSA: build.mutation<
      TAnimalTypeChangeResultUI,
      TConvertAnimalToSaUI
    >({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.TYPE}/${EAnimalUrls.TO_SA}`,
          method: 'PATCH',
          body: convertAnimalToSAConverter.toDb(body),
        };
      },
      // PP-10057: the conversion can leave applications retracted at properties that do not manage
      // the new type; the caller shows the tenant which residency was affected.
      transformResponse: (data: TAnimalTypeChangeResultDB) =>
        animalTypeChangeResultConvertor.fromDb(data),
      invalidatesTags: ['animal', 'animals', 'incompleteAnimals'],
    }),
    updateAnimalToSAConversion: build.mutation<void, TConvertAnimalToSaUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.TYPE}/${EAnimalUrls.TO_SA}`,
          method: 'PUT',
          body: convertAnimalToSAConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'incompleteAnimals'],
    }),
    // updateAnimalConversionHPDocs: build.mutation<
    //   void,
    //   TUpdateAnimalConvHPDocsUI
    // >({
    //   query(body) {
    //     return {
    //       url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.CONVERSION}/${EAnimalUrls.HP_DOC}`,
    //       method: 'PATCH',
    //       body: updateAnimalConversionHPDocsConverter.toDb(body),
    //     };
    //   },
    //   invalidatesTags: ['animal'],
    // }),
    getAnimal: build.query<TAnimalDetailsUi, string>({
      query(id) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${id}`,
          method: 'GET',
        };
      },
      providesTags: ['animal'],
      transformResponse: (data: TAnimalDetails) =>
        animalDetailsConverter.fromDb(data),
    }),
    getIncompleteAnimals: build.query<TIncompleteAnimalsDataUI, void>({
      query() {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.INCOMPLETE}`,
          method: 'GET',
        };
      },
      providesTags: ['incompleteAnimals'],
      transformResponse: (data: TIncompleteAnimalsDataDB) =>
        incompleteAnimalsData.fromDb(data),
    }),
    getAnimalById: build.query<TAnimalDetailsByIdUi, string>({
      query(id) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${id}`,
          method: 'GET',
        };
      },
      providesTags: ['animalById'],
      transformResponse: (data: TAnimalDetailsById) =>
        animalDetailsByIdConverter.fromDb(data),
    }),
    getApplicationAnimal: build.query<
      TApplicationAnimalUI,
      // { animalId: string; leasePacketId?: string }
      { applicationId: string }
    >({
      query({ applicationId }) {
        return {
          url: `${EApplicationUrls.APPLICATION}/${EApplicationUrls.STEP}/${EApplicationUrls.ANIMAL}/${EApplicationUrls.DETAILS}`,
          method: 'GET',
          params: {
            applicationId,
          },
        };
      },
      transformResponse: (data: TApplicationAnimal) =>
        applicationAnimalConvertor.fromDb(data),
      providesTags: ['applicationAnimal'],
    }),
    getAnimalVetRecordsList: build.query<TAnimalVetRecordsListUi[], string>({
      query(id) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${id}/${EAnimalUrls.VET_RECORDS}`,
          method: 'GET',
        };
      },
      providesTags: ['vetRecords'],
      transformResponse: (data: TAnimalVetRecordsList[]) =>
        data?.map(item => animalVetRecordConvertor.fromDb(item)) || [],
    }),
    getAnimalMetadata: build.query<TAnimalMetadataUi, string>({
      query(id) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${id}/${EAnimalUrls.METADATA}`,
          method: 'GET',
        };
      },
      providesTags: ['animalMetadata'],
      transformResponse: (data: TAnimalMetadata) =>
        animalMetadataConverter.fromDb(data),
    }),

    updateVetRecord: build.mutation<void, TVetRecordDocumentsUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.VET_RECORDS_UPD}`,
          method: 'PUT',
          body: updateVaccinationRecordsConverter.toDb(body),
        };
      },
      invalidatesTags: ['vetRecords', 'animal', 'applicationAnimal'],
    }),
    deleteVetRecord: build.mutation<void, TVetRecordUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.VET_RECORDS}`,
          method: 'DELETE',
          body: deleteVetRecordConvertor.toDb(body),
        };
      },
      invalidatesTags: ['vetRecords', 'animal', 'applicationAnimal'],
    }),
    getAnimalSpecies: build.query<TOptionTypeUi[], void>({
      query() {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.SPECIES}`,
          method: 'GET',
        };
      },
      providesTags: ['species'],
      transformResponse: (data: TOptionType[]) => {
        return getAnimalInfoListConvertor.fromDb(data);
      },
    }),
    getAnimalBreeds: build.query<TOptionTypeUi[], { speciesId?: string }>({
      query({ speciesId }) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.BREEDS}`,
          method: 'GET',
          params: { speciesId },
        };
      },
      providesTags: ['breeds'],
      transformResponse: (data: TOptionType[]) => {
        return getAnimalInfoListConvertor.fromDb(data);
      },
    }),
    getAnimalColors: build.query<TOptionTypeUi[], void>({
      query() {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.COLORS}`,
          method: 'GET',
        };
      },
      providesTags: ['colors'],
      transformResponse: (data: TOptionType[]) => {
        return getAnimalInfoListConvertor.fromDb(data);
      },
    }),
    updateAnimalProfileImage: build.mutation<void, TAnimalProfileUpdateUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/profilePicture`,
          method: 'PATCH',
          body: animalProfilePictureUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    updateAnimalName: build.mutation<void, TAnimalNameUpdateUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/name`,
          method: 'PATCH',
          body: animalNameUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    updateAnimalGender: build.mutation<void, TAnimalGenderUpdateUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/gender`,
          method: 'PATCH',
          body: animalGenderUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    updateAnimalHouseTrained: build.mutation<void, TAnimalHouseTrainedUpdateUi>(
      {
        query(body) {
          return {
            url: `${EAnimalUrls.ANIMALS}/houseTrained`,
            method: 'PATCH',
            body: animalHouseTrainedUpdateConverter.toDb(body),
          };
        },
        invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
      },
    ),
    updateAnimalBreed: build.mutation<void, TAnimalBreedUpdateUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/breed`,
          method: 'PATCH',
          body: animalBreedUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    updateAnimalSpecies: build.mutation<void, TAnimalSpeciesUpdateUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/species`,
          method: 'PATCH',
          body: animalSpeciesUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    updateAnimalColors: build.mutation<void, TUpdateAnimalColorsUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/colors`,
          method: 'PATCH',
          body: updateAnimalColorsConvertor.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    updateAnimalReproductive: build.mutation<void, TAnimalReproductiveUpdateUi>(
      {
        query(body) {
          return {
            url: `${EAnimalUrls.ANIMALS}/reproductive`,
            method: 'PATCH',
            body: animalReproductiveUpdateConverter.toDb(body),
          };
        },
        invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
      },
    ),
    updateAnimalBirth: build.mutation<void, TAnimalBirthDateUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/birthDate`,
          method: 'PATCH',
          body: animalBirthUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    updateAnimalWeight: build.mutation<void, TAnimalWeightUpdateUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/weight`,
          method: 'PATCH',
          body: animalWeightUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    updateAnimalTrainedFor: build.mutation<void, TAnimalTrainedForUpdateUi>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/trainedFor`,
          method: 'PATCH',
          body: animalTrainedForUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    moveOutAnimal: build.mutation<void, TMoveOutFormUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.MOVE_OUT}`,
          method: 'PATCH',
          body: animalMoveOutConvertor.toDb(body),
        };
      },
      invalidatesTags: ['animals', 'applicationAnimal'],
    }),
    moveOutPreview: build.query<TUnAuthorizedResidencyUI[], string>({
      query(animalId) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.MOVE_OUT}/${EAnimalUrls.PREVIEW}`,
          method: 'GET',
          params: { animalId },
        };
      },
      providesTags: ['moveOutPreview'],
      transformResponse: (data: {
        unAuthorizedResidencies: TUnAuthorizedResidencyDB[];
      }) => {
        return (data.unAuthorizedResidencies || []).map(item =>
          unAuthorizedResidencyConverter.fromDb(item),
        );
      },
    }),
    updateAnimalAggressionBehavor: build.mutation<
      void,
      TAnimalAggressionUpdateUI
    >({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.AGGRESIVE_BEHAVOR}`,
          method: 'PATCH',
          body: animalAggressionUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    updateMicrochipNumber: build.mutation<void, TAnimalMicrochipUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.MICROCHIP_NUMBER}`,
          method: 'PATCH',
          body: animalMicrochipUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['animal', 'animals', 'applicationAnimal'],
    }),
    confirmAnimalStatus: build.mutation<void, TConfirmAnimalTypeUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.TYPE}/${EAnimalUrls.CONFIRM}`,
          method: 'PATCH',
          body,
        };
      },
    }),
    animalsConversionAcknowledgment: build.query<
      TConvertedToPetAcknowledgmentUI[],
      void
    >({
      query() {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.CONVERSION}/${EAnimalUrls.ACKNOWLEDGMENT}`,
          method: 'GET',
        };
      },
      providesTags: ['convertedToPet'],

      transformResponse: (data: TConvertedToPetAcknowledgmentDB[]) => {
        return (data || []).map(item =>
          animalConvertedAcknowledgmentConverter.fromDb(item),
        );
      },
    }),
    animalsConversionAcknowledgmentResolve: build.mutation<
      void,
      TConvertedToPetResolveUI
    >({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.CONVERSION}/${EAnimalUrls.ACKNOWLEDGMENT}/${EAnimalUrls.RESOLVE}`,
          method: 'PATCH',
          body,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateIncompleteAnimalMutation,
  useCreateAnimalMutation,
  useCompleteAnimalMutation,
  useConvertAnimalToPetMutation,
  useConvertAnimalToESAMutation,
  useConvertAnimalToSAMutation,
  // useUpdateAnimalConversionHPDocsMutation,
  useCreateVetRecordMutation,
  useConfirmPaymentMutation,
  useDeleteVetRecordMutation,
  useGetAnimalsQuery,
  useGetAnimalSpeciesQuery,
  useGetAnimalBreedsQuery,
  useGetAnimalColorsQuery,
  useGetAnimalQuery,
  useGetAnimalByIdQuery,
  useGetAnimalMetadataQuery,
  useGetApplicationAnimalQuery,
  useUpdateAnimalProfileImageMutation,
  useUpdateAnimalNameMutation,
  useUpdateAnimalGenderMutation,
  useUpdateAnimalBreedMutation,
  useUpdateAnimalHouseTrainedMutation,
  useUpdateAnimalColorsMutation,
  useUpdateAnimalReproductiveMutation,
  useUpdateAnimalSpeciesMutation,
  useUpdateAnimalBirthMutation,
  useUpdateAnimalWeightMutation,
  useUpdateAnimalTrainedForMutation,
  useMoveOutAnimalMutation,
  useMoveOutPreviewQuery,
  useGetIncompleteAnimalsQuery,
  useUpdateVetRecordMutation,
  useUpdateAnimalAggressionBehavorMutation,
  useConfirmAnimalStatusMutation,
  useAnimalsConversionAcknowledgmentQuery,
  useAnimalsConversionAcknowledgmentResolveMutation,
  useUpdateAnimalToSAConversionMutation,
  useUpdateAnimalToESAConversionMutation,
  useUpdateMicrochipNumberMutation,
} = animalApi;
